const title = 'Delete Item?';
const bodyText =
  'Once you delete this item, its related data will also be deleted. This cannot be undone. Are you sure you want to delete the item?';
const btnCancelText = 'Cancel';
const btnSaveText = 'Submit';

export { title, bodyText, btnCancelText, btnSaveText };
